import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, withModifiers as _withModifiers, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, renderSlot as _renderSlot, createStaticVNode as _createStaticVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6a9dc4aa")

_pushScopeId("data-v-6a9dc4aa")
const _hoisted_1 = { class: "md:flex flex-col md:flex-row md:min-h-screen mt-4 mx-4" }
const _hoisted_2 = {
  class: "md:col-span-1 md:grid-cols-1",
  style: {"display":"unset"}
}
const _hoisted_3 = { class: "mx-auto max-w-4xl w-full text-white col-start-3 md:col-span-6 md:grid-cols-6 justify-self-center lg:justify-self-stretch" }
const _hoisted_4 = { class: "z-0 text-xl font-medium text-white bg-gray-70 text-center\n      " }
const _hoisted_5 = { class: "z-0 text-3xl bold text-bp-dark bg-gray-70 text-center\n      p-5 pt-2 pb-0" }
const _hoisted_6 = { class: "container text-center pb-5" }
const _hoisted_7 = { class: "bp-font-text my-12" }
const _hoisted_8 = { class: "z-0 text-3xl bold text-bp-dark bg-gray-70 text-center\n     p-5 pt-2 pb-0" }
const _hoisted_9 = { class: "container md:flex text-center pb-5" }
const _hoisted_10 = { class: "z-0 text-3xl bold text-bp-dark bg-gray-70 text-center\n     p-5 pt-2 pb-0" }
const _hoisted_11 = { class: "container text-center pb-5" }
const _hoisted_12 = { class: "flex m-4 space-x-4" }
const _hoisted_13 = { class: "text-gray-700 dark:text-gray-400" }
const _hoisted_14 = /*#__PURE__*/_createVNode("input", { type: "checkbox" }, null, -1)
const _hoisted_15 = { class: "text-gray-700 dark:text-gray-400" }
const _hoisted_16 = /*#__PURE__*/_createVNode("input", { type: "checkbox" }, null, -1)
const _hoisted_17 = { class: "z-0 text-3xl bold text-bp-dark bg-gray-70 text-center\n     p-5 pt-2 pb-0" }
const _hoisted_18 = { class: "container text-center pb-5" }
const _hoisted_19 = { class: "my-4 pb-5 mx-auto w-3/4" }
const _hoisted_20 = { class: "bp-font-text" }
const _hoisted_21 = { class: "flex  w-auto m-auto items-center justify-center" }
const _hoisted_22 = { class: "py-1 relative min-w-full" }
const _hoisted_23 = { class: "h-2 bg-gray-200 dark:bg-gray-500 rounded-full" }
const _hoisted_24 = /*#__PURE__*/_createVNode("div", {
  class: "absolute h-2 rounded-full bg-teal-600 w-0",
  style: {"width":"58.5714%"}
}, null, -1)
const _hoisted_25 = /*#__PURE__*/_createVNode("div", {
  class: "absolute h-4 flex items-center justify-center w-4 rounded-full bg-bp shadow  -ml-2 top-0 cursor-pointer",
  onselectstart: "return false;",
  style: {"left":"58.5714%"},
  unselectable: "on"
}, [
  /*#__PURE__*/_createVNode("div", { class: "relative -mt-2 w-1" }, [
    /*#__PURE__*/_createVNode("div", {
      class: "absolute z-40 opacity-100 bottom-100 mb-2 left-0 min-w-full",
      style: {"margin-left":"-20.5px"}
    })
  ])
], -1)
const _hoisted_26 = { class: "absolute text-gray-800 dark:text-gray-400 -ml-1 bottom-0 left-0 -mb-6" }
const _hoisted_27 = { class: "absolute text-gray-800 dark:text-gray-400 -mr-1 bottom-0 right-0 -mb-6" }
const _hoisted_28 = { class: "mt-4" }
const _hoisted_29 = { class: "z-0 text-sm bold text-bp-dark bg-gray-70 text-center\n     p-5 pt-2 pb-0" }
const _hoisted_30 = { class: "z-0 text-center text-3xl bold text-bp-dark bg-gray-70\n     p-5 pt-2 pb-0" }
const _hoisted_31 = { class: "container center-text pb-5" }
const _hoisted_32 = /*#__PURE__*/_createVNode("div", { class: "flex mx-auto p-2 sm:p-5" }, [
  /*#__PURE__*/_createVNode("svg", {
    viewBox: "0 0 448 448",
    width: "32",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createVNode("path", { d: "m314.375 144h-180.75l90.375 77.464844zm0 0" }),
    /*#__PURE__*/_createVNode("path", { d: "m224 240c-1.910156 0-3.757812-.683594-5.207031-1.929688l-98.792969-84.679687v150.609375h208v-150.609375l-98.792969 84.679687c-1.449219 1.246094-3.296875 1.929688-5.207031 1.929688zm0 0" }),
    /*#__PURE__*/_createVNode("path", { d: "m224 0c-123.710938 0-224 100.289062-224 224s100.289062 224 224 224 224-100.289062 224-224c-.140625-123.652344-100.347656-223.859375-224-224zm120 312c0 4.417969-3.582031 8-8 8h-224c-4.417969 0-8-3.582031-8-8v-176c0-4.417969 3.582031-8 8-8h224c4.417969 0 8 3.582031 8 8zm0 0" })
  ])
], -1)
const _hoisted_33 = { class: "ml-2 sm:ml-5" }
const _hoisted_34 = { class: "z-0 text-sm font-bold text-bp-dark bg-gray-70\n         " }
const _hoisted_35 = { class: "z-0 text-sm text-bp-dark bg-gray-70\n         " }
const _hoisted_36 = { class: "z-0 text-sm font-bold text-bp-dark bg-gray-70\n         " }
const _hoisted_37 = { class: "sm:ml-2 text-center" }
const _hoisted_38 = { class: "container center-text pb-5" }
const _hoisted_39 = { class: "flex mx-auto p-2 sm:p-5" }
const _hoisted_40 = /*#__PURE__*/_createVNode("svg", {
  "enable-background": "new 0 0 24 24",
  height: "32",
  viewBox: "0 0 24 24",
  width: "32",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createVNode("circle", {
    cx: "12",
    cy: "12",
    fill: "#039be5",
    r: "12"
  }),
  /*#__PURE__*/_createVNode("path", {
    d: "m5.491 11.74 11.57-4.461c.537-.194 1.006.131.832.943l.001-.001-1.97 9.281c-.146.658-.537.818-1.084.508l-3-2.211-1.447 1.394c-.16.16-.295.295-.605.295l.213-3.053 5.56-5.023c.242-.213-.054-.333-.373-.121l-6.871 4.326-2.962-.924c-.643-.204-.657-.643.136-.953z",
    fill: "#fff"
  })
], -1)
const _hoisted_41 = { class: "pl-4 bp-font-text" }
const _hoisted_42 = { class: "ml-2 sm:ml-5" }
const _hoisted_43 = { class: "z-0 text-sm font-bold text-bp-dark bg-gray-70\n         " }
const _hoisted_44 = { class: "z-0 text-sm text-bp-dark bg-gray-70\n         " }
const _hoisted_45 = { class: " pt-5 z-0 text-sm font-bold text-bp-dark bg-gray-70\n         " }
const _hoisted_46 = { class: "sm:ml-2" }
const _hoisted_47 = { class: "container center-text pb-5" }
const _hoisted_48 = /*#__PURE__*/_createVNode("div", { class: "flex mx-auto p-2 sm:p-5" }, [
  /*#__PURE__*/_createVNode("svg", {
    viewBox: "0 0 448 448",
    width: "32",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createVNode("path", { d: "m314.375 144h-180.75l90.375 77.464844zm0 0" }),
    /*#__PURE__*/_createVNode("path", { d: "m224 240c-1.910156 0-3.757812-.683594-5.207031-1.929688l-98.792969-84.679687v150.609375h208v-150.609375l-98.792969 84.679687c-1.449219 1.246094-3.296875 1.929688-5.207031 1.929688zm0 0" }),
    /*#__PURE__*/_createVNode("path", { d: "m224 0c-123.710938 0-224 100.289062-224 224s100.289062 224 224 224 224-100.289062 224-224c-.140625-123.652344-100.347656-223.859375-224-224zm120 312c0 4.417969-3.582031 8-8 8h-224c-4.417969 0-8-3.582031-8-8v-176c0-4.417969 3.582031-8 8-8h224c4.417969 0 8 3.582031 8 8zm0 0" })
  ])
], -1)
const _hoisted_49 = { class: "ml-2 sm:ml-5" }
const _hoisted_50 = { class: "z-0 text-sm font-bold text-bp-dark bg-gray-70\n         " }
const _hoisted_51 = { class: "z-0 text-sm text-bp-dark bg-gray-70\n         " }
const _hoisted_52 = { class: "z-0 text-sm font-bold text-bp-dark bg-gray-70\n         " }
const _hoisted_53 = { class: "sm:ml-2" }
const _hoisted_54 = { class: "container center-text pb-5" }
const _hoisted_55 = { class: "flex mx-auto p-2 sm:p-5" }
const _hoisted_56 = /*#__PURE__*/_createVNode("svg", {
  height: "32.02",
  viewBox: "0 0 31.999 32.02",
  width: "31.999",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createVNode("g", { transform: "translate(22175 -11192.32)" }, [
    /*#__PURE__*/_createVNode("path", {
      d: "M739.7,204.849c-2.044,0-3.734-.014-5.318-.045a9.466,9.466,0,0,1-7.888-4.128A8.05,8.05,0,0,1,725,195.9V182.03a8.769,8.769,0,0,1,1.327-4.835,10.031,10.031,0,0,1,8.341-4.356c1.09,0,2.277,0,3.628,0h.908q1.362,0,2.724,0c2.06,0,3.77.007,5.383.022a9.7,9.7,0,0,1,8.01,3.909,8.083,8.083,0,0,1,1.664,5.018v7.056c0,.574,0,1.161-.006,1.728l0,.307v.019c-.01,1.531-.02,3.114.021,4.686a8.577,8.577,0,0,1-1.561,5.182,9.464,9.464,0,0,1-4.018,3.228,10.1,10.1,0,0,1-4.006.838c-1.122,0-2.236.007-3.473.013h-.025l-.352,0C742.3,204.843,740.993,204.849,739.7,204.849Zm1.312-24.013a7.515,7.515,0,0,0-5.353,2.218,7.265,7.265,0,0,0-2.154,5.173,7.374,7.374,0,0,0,2.2,5.269,7.465,7.465,0,1,0,5.318-12.66Zm8.391-2.258a1.53,1.53,0,0,0-1.09.461,1.667,1.667,0,0,0-.484,1.2,1.607,1.607,0,0,0,1.561,1.632h.011a1.646,1.646,0,0,0,0-3.29Zm-8.377,14.706h-.012a5.035,5.035,0,1,1,5.133-5.05,4.971,4.971,0,0,1-1.467,3.541A5.125,5.125,0,0,1,741.029,193.284Z",
      fill: "#ededed",
      transform: "translate(-22900 11019.49)"
    })
  ])
], -1)
const _hoisted_57 = { class: "pl-4 bp-font-text" }
const _hoisted_58 = { class: "ml-2 sm:ml-5" }
const _hoisted_59 = { class: "z-0 text-sm bold text-bp-dark bg-gray-70\n         pb-4 pt-2" }
const _hoisted_60 = { class: "sm:float-left sm:mx-6 sm:mb-6" }
const _hoisted_61 = { class: "z-0 text-3xl bold text-bp-dark bg-gray-70 text-center\n     p-5 pt-2 pb-0" }
const _hoisted_62 = /*#__PURE__*/_createStaticVNode("<div class=\"sm:m-6 lg:m-20 grid sm:grid-cols-2 justify-items-center\" data-v-6a9dc4aa><img alt=\"\" class=\"col m-2 p-6 dark:bg-gray-600 bg-gray-300 h-32 w-48 rounded-3xl\" src=\"/img/test/PayPal.svg\" data-v-6a9dc4aa><img alt=\"\" class=\"col m-2 p-6 pt-8 dark:bg-gray-600 bg-gray-300 h-32 w-48 rounded-3xl\" src=\"/img/test/Amazon.svg\" data-v-6a9dc4aa><img alt=\"\" class=\"col m-2 p-6 dark:bg-gray-600 bg-gray-300 h-32 w-48 rounded-3xl\" src=\"/img/test/Crypto.svg\" data-v-6a9dc4aa><img alt=\"\" class=\"col m-2 p-10 dark:bg-gray-600 bg-gray-300 h-32 w-48 rounded-3xl\" src=\"/img/test/Card.svg\" data-v-6a9dc4aa></div>", 1)
const _hoisted_63 = { class: "grid sm:grid-cols-2 mx-4 justify-self-center" }
const _hoisted_64 = { class: "p-4 text-gray-700 " }
const _hoisted_65 = { class: "z-0 text-3xl bold text-bp-dark bg-gray-70 text-center\n     p-5 pt-2 pb-0" }
const _hoisted_66 = { class: "text-center" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_sidebar_profile = _resolveComponent("sidebar-profile")
  const _component_btn_close = _resolveComponent("btn-close")
  const _component_DefaultCardLayout = _resolveComponent("DefaultCardLayout")
  const _component_default_button = _resolveComponent("default-button")
  const _component_input_field = _resolveComponent("input-field")
  const _component_credit_card = _resolveComponent("credit-card")
  const _component_DeleteProfileDialog = _resolveComponent("DeleteProfileDialog")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_sidebar_profile)
    ]),
    _createVNode("div", _hoisted_3, [
      _createVNode("div", null, [
        _createVNode(_component_btn_close, { "btn-position": "mr-7 -mt-1" }),
        _createVNode(_component_DefaultCardLayout, {
          "card-bg": "bg-bp",
          "card-margin": "m-3",
          "card-padding": "px-4 sm:px-6 md:px-1"
        }, {
          default: _withId(() => [
            _createVNode("h1", _hoisted_4, _toDisplayString(_ctx.$t("profile.settings.notificationText")), 1)
          ]),
          _: 1
        })
      ]),
      _createVNode(_component_DefaultCardLayout, { "card-padding": "px-4 sm:px-6" }, {
        default: _withId(() => [
          _createVNode("h1", _hoisted_5, _toDisplayString(_ctx.$t("profile.settings.confirmationTitle")), 1),
          _createVNode("form", {
            class: "space-y-5 mt-5",
            onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["prevent"]))
          }, [
            _createVNode("div", _hoisted_6, [
              _createVNode("h1", _hoisted_7, _toDisplayString(_ctx.$t("profile.settings.confirmationDetail")), 1),
              _createVNode(_component_default_button, {
                "button-text": _ctx.$t('profile.settings.confirmationBtn'),
                "button-width": "w-auto",
                "flex-button": ""
              }, null, 8, ["button-text"])
            ])
          ], 32)
        ]),
        _: 1
      }),
      _createVNode(_component_DefaultCardLayout, {
        "card-margin": "my-6",
        "card-padding": "px-4 sm:px-6"
      }, {
        default: _withId(() => [
          _createVNode("h1", _hoisted_8, _toDisplayString(_ctx.$t("profile.settings.informationTitle")), 1),
          _createVNode("form", {
            class: "space-y-5 mt-5",
            onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["prevent"]))
          }, [
            _createVNode("div", _hoisted_9, [
              _createVNode(_component_input_field, {
                "input-placeholder": _ctx.$t('profile.settings.informationPlaceholderPicture'),
                "i-height": "h-32",
                "i-rounded": "rounded-full rounded-3xl",
                "i-width": "w-32",
                "input-id": "Profile Picture"
              }, null, 8, ["input-placeholder"]),
              _createVNode(_component_input_field, {
                "input-placeholder": _ctx.$t('profile.settings.informationPlaceholderDetail'),
                "i-height": "h-32",
                "i-width": "w-full md:w-3/4",
                "input-id": "Text About You",
                "text-position": "break-words"
              }, null, 8, ["input-placeholder"])
            ])
          ], 32)
        ]),
        _: 1
      }),
      _createVNode(_component_DefaultCardLayout, { "card-padding": "px-4 sm:px-6" }, {
        default: _withId(() => [
          _createVNode("h1", _hoisted_10, _toDisplayString(_ctx.$t("profile.settings.creatorTitle")), 1),
          _createVNode("form", {
            class: "space-y-5 mt-5",
            onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["prevent"]))
          }, [
            _createVNode("div", _hoisted_11, [
              _createVNode(_component_input_field, {
                "input-placeholder": _ctx.$t('profile.settings.creatorPlaceholderNickname'),
                "input-id": "Nickname",
                "input-width": ""
              }, null, 8, ["input-placeholder"]),
              _createVNode(_component_input_field, {
                "input-placeholder": _ctx.$t('profile.settings.creatorPlaceholderStreet'),
                "input-id": "Street",
                "input-width": ""
              }, null, 8, ["input-placeholder"]),
              _createVNode(_component_input_field, {
                "input-placeholder": _ctx.$t('profile.settings.creatorPlaceholderTown'),
                "input-id": "Town",
                "input-width": ""
              }, null, 8, ["input-placeholder"]),
              _createVNode(_component_input_field, {
                "input-placeholder": _ctx.$t('profile.settings.creatorPlaceholderZip'),
                "input-id": "ZIP",
                "input-width": ""
              }, null, 8, ["input-placeholder"]),
              _createVNode(_component_input_field, {
                "input-placeholder": _ctx.$t('profile.settings.creatorPlaceholderState'),
                "input-id": "Street",
                "input-width": ""
              }, null, 8, ["input-placeholder"]),
              _createVNode(_component_input_field, {
                "input-placeholder": _ctx.$t('profile.settings.creatorPlaceholderCountry'),
                "input-id": "Street",
                "input-width": ""
              }, null, 8, ["input-placeholder"]),
              _createVNode("div", _hoisted_12, [
                _createVNode("div", _hoisted_13, [
                  _hoisted_14,
                  _createTextVNode(" " + _toDisplayString(_ctx.$t("profile.settings.creatorPrivacy")), 1)
                ]),
                _createVNode("div", _hoisted_15, [
                  _hoisted_16,
                  _createTextVNode(" " + _toDisplayString(_ctx.$t("profile.settings.creatorCompany")), 1)
                ])
              ]),
              _createVNode(_component_input_field, {
                "input-placeholder": _ctx.$t('profile.settings.creatorVat'),
                "input-id": "VAT",
                "input-width": ""
              }, null, 8, ["input-placeholder"]),
              _createVNode(_component_input_field, {
                "input-placeholder": _ctx.$t('profile.settings.creatorWebsite'),
                "input-id": "Website",
                "input-width": ""
              }, null, 8, ["input-placeholder"])
            ])
          ], 32)
        ]),
        _: 1
      }),
      _createVNode(_component_DefaultCardLayout, { "card-padding": "px-4 sm:px-6" }, {
        default: _withId(() => [
          _createVNode("h1", _hoisted_17, _toDisplayString(_ctx.$t("profile.settings.authTitle")), 1),
          _createVNode("form", {
            class: "space-y-5 mt-5",
            onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["prevent"]))
          }, [
            _createVNode("div", _hoisted_18, [
              _createVNode(_component_input_field, {
                "input-placeholder": _ctx.$t('profile.settings.authInputMail'),
                "input-id": "Mail",
                "input-width": ""
              }, null, 8, ["input-placeholder"]),
              _createVNode(_component_input_field, {
                "input-placeholder": _ctx.$t('profile.settings.authInputPhone'),
                "input-id": "Phone",
                "input-width": ""
              }, null, 8, ["input-placeholder"]),
              _createVNode(_component_input_field, {
                "input-placeholder": _ctx.$t('profile.settings.authInputOldPassword'),
                "input-id": "old Password",
                "input-width": ""
              }, null, 8, ["input-placeholder"]),
              _createVNode(_component_input_field, {
                "input-placeholder": _ctx.$t('profile.settings.authInputNewPassword'),
                "input-id": "new Password",
                "input-width": ""
              }, null, 8, ["input-placeholder"]),
              _createVNode("div", _hoisted_19, [
                _createVNode("div", _hoisted_20, _toDisplayString(_ctx.$t("profile.settings.factorTitle")), 1),
                _createVNode("div", _hoisted_21, [
                  _createVNode("div", _hoisted_22, [
                    _createVNode("div", _hoisted_23, [
                      _hoisted_24,
                      _hoisted_25,
                      _createVNode("div", _hoisted_26, _toDisplayString(_ctx.$t("profile.settings.btnDisable")), 1),
                      _createVNode("div", _hoisted_27, _toDisplayString(_ctx.$t("profile.settings.btnEnable")), 1)
                    ])
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_28, [
                _createVNode(_component_input_field, {
                  "input-placeholder": _ctx.$t('profile.settings.factorQrTitle'),
                  "css-class": "mx-auto text-center",
                  "i-height": "h-36",
                  "i-width": "w-36",
                  "input-id": "QR Code"
                }, null, 8, ["input-placeholder"]),
                _createVNode("h1", _hoisted_29, _toDisplayString(_ctx.$t("profile.settings.factorQrApp")), 1)
              ])
            ])
          ], 32)
        ]),
        _: 1
      }),
      _createVNode(_component_DefaultCardLayout, { "card-padding": "px-4 sm:px-6" }, {
        default: _withId(() => [
          _createVNode("h1", _hoisted_30, _toDisplayString(_ctx.$t("profile.settings.channelTitle")), 1),
          _createVNode("form", {
            class: "space-y-5 mt-5",
            onSubmit: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["prevent"]))
          }, [
            _createVNode("div", _hoisted_31, [
              _createVNode("div", null, [
                _hoisted_32,
                _createVNode("div", _hoisted_33, [
                  _createVNode("h1", _hoisted_34, _toDisplayString(_ctx.$t("profile.settings.channelEmailTitle")), 1),
                  _createVNode("h1", _hoisted_35, _toDisplayString(_ctx.$t("profile.settings.channelEmailDetail")), 1),
                  _createVNode("h1", _hoisted_36, _toDisplayString(_ctx.$t("profile.settings.channelEmailInfo")), 1)
                ]),
                _createVNode("div", _hoisted_37, [
                  _createVNode(_component_input_field, {
                    "input-placeholder": _ctx.$t('profile.settings.channelPlaceholderEmail'),
                    "input-id": "E-Mail",
                    "input-width": ""
                  }, null, 8, ["input-placeholder"]),
                  _createVNode(_component_input_field, {
                    "input-placeholder": _ctx.$t('profile.settings.channelPlaceholderEmailList'),
                    "input-id": "E-Mail List",
                    "input-width": ""
                  }, null, 8, ["input-placeholder"])
                ])
              ])
            ]),
            _createVNode("div", _hoisted_38, [
              _createVNode("div", null, [
                _createVNode("div", _hoisted_39, [
                  _hoisted_40,
                  _createVNode("h1", _hoisted_41, _toDisplayString(_ctx.$t("profile.settings.channelTelegramTitle")), 1)
                ]),
                _createVNode("div", _hoisted_42, [
                  _createVNode("h1", _hoisted_43, _toDisplayString(_ctx.$t("profile.settings.channelTelegramDetail")), 1),
                  _createVNode("h1", _hoisted_44, _toDisplayString(_ctx.$t("profile.settings.channelTelegramDetail2")), 1),
                  _createVNode("h1", _hoisted_45, _toDisplayString(_ctx.$t("profile.settings.channelTelegramDetail3")), 1)
                ]),
                _createVNode("div", _hoisted_46, [
                  _createVNode(_component_input_field, {
                    "input-placeholder": _ctx.$t('profile.settings.channelTelegramCode'),
                    "input-id": "Telegram Code",
                    "input-width": ""
                  }, null, 8, ["input-placeholder"])
                ])
              ])
            ]),
            _createVNode("div", _hoisted_47, [
              _createVNode("div", null, [
                _hoisted_48,
                _createVNode("div", _hoisted_49, [
                  _createVNode("h1", _hoisted_50, _toDisplayString(_ctx.$t("profile.settings.channelCalendarTitle")), 1),
                  _createVNode("h1", _hoisted_51, _toDisplayString(_ctx.$t("profile.settings.channelCalendarLink")), 1),
                  _createVNode("h1", _hoisted_52, _toDisplayString(_ctx.$t("profile.settings.channelCalendarCode")), 1)
                ]),
                _createVNode("div", _hoisted_53, [
                  _createVNode(_component_input_field, {
                    "input-placeholder": _ctx.$t('profile.settings.channelCalendarPlaceholder'),
                    "input-id": "Calendar",
                    "input-width": ""
                  }, null, 8, ["input-placeholder"])
                ])
              ])
            ]),
            _createVNode("div", _hoisted_54, [
              _createVNode("div", null, [
                _createVNode("div", _hoisted_55, [
                  _hoisted_56,
                  _createVNode("h1", _hoisted_57, _toDisplayString(_ctx.$t("profile.settings.channelInstagramTitle")), 1)
                ]),
                _createVNode("div", _hoisted_58, [
                  _createVNode("h1", _hoisted_59, _toDisplayString(_ctx.$t("profile.settings.channelInstagramInfo")), 1)
                ]),
                _createVNode("div", _hoisted_60, [
                  _createVNode(_component_default_button, {
                    "button-text": _ctx.$t('profile.settings.channelBtnInstagram'),
                    "button-width": "w-auto",
                    "button-x-padding": "p-10"
                  }, null, 8, ["button-text"])
                ])
              ])
            ])
          ], 32)
        ]),
        _: 1
      }),
      _createVNode(_component_DefaultCardLayout, { "card-padding": "px-4 sm:px-6 mb-6" }, {
        default: _withId(() => [
          _createVNode("h1", _hoisted_61, _toDisplayString(_ctx.$t("profile.settings.invoiceTitle")), 1),
          _createVNode("form", {
            class: "space-y-5 mt-5",
            onSubmit: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["prevent"]))
          }, [
            _createVNode(_component_credit_card),
            _hoisted_62,
            _createVNode("div", _hoisted_63, [
              _createVNode("div", _hoisted_64, _toDisplayString(_ctx.$t("profile.settings.invoiceName")) + " " + _toDisplayString(_ctx.$t("profile.settings.invoiceNumber")) + " & " + _toDisplayString($props.invoiceDate), 1),
              _createVNode(_component_default_button, {
                "button-text": _ctx.$t('profile.settings.downloadBtn'),
                "button-width": "w-auto",
                "button-x-padding": "px-7"
              }, null, 8, ["button-text"])
            ])
          ], 32)
        ]),
        _: 1
      }),
      _createVNode(_component_DefaultCardLayout, { "card-padding": "px-4 sm:px-6 mb-6" }, {
        default: _withId(() => [
          _createVNode("h1", _hoisted_65, _toDisplayString(_ctx.$t("profile.settings.accountDataTitle")), 1),
          _createVNode("form", {
            class: "space-y-10 text-center mt-5",
            onSubmit: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["prevent"]))
          }, [
            _createVNode(_component_default_button, {
              "button-text": _ctx.$t('profile.settings.downloadBtn'),
              "button-width": "w-auto",
              "flex-button": ""
            }, null, 8, ["button-text"]),
            _createVNode("div", _hoisted_66, [
              _renderSlot(_ctx.$slots, "EditSubscribtionButton", {}, () => [
                _createVNode(_component_DeleteProfileDialog, { class: "mr-1 absolute" })
              ])
            ])
          ], 32)
        ]),
        _: 3
      })
    ])
  ]))
})